<div class="product-form">
  <div class="input">
    <span>{{ labels.productNamePlaceholder }}:<span class="required"> *</span></span>
    <app-input
      class="product-form"
      [control]="getControl('name')"
      [placeholder]="labels.typeNameOfProduct"
    ></app-input>
  </div>
  <div class="image">
    <span>{{ labels.productImage }}</span>
    <app-product-image-upload [picture]="getControl('image')"></app-product-image-upload>
  </div>
  <div class="family">
    <span>{{ labels.selectPrinterFamily }}:<span class="required"> *</span></span>
    <app-multi-select *ngIf="productFamilies.length > 0"
                      [options]="productFamilies"
                      [disabled]="!!product"
                      [initialData]="getFamilyOptionSelected()"
                      (valueChange)="onOptionSelected($event)"
    ></app-multi-select>
  </div>
  <div class="headers">
      <span>{{ labels.printerHeadersNote }}:<span class="required"> *</span></span>
      <app-input
        class="product-form"
        [control]="headerInputControl"
        [placeholder]="labels.printerHeadersPlaceholder"
        (keydown)="onHeaderKey($event)"
      ></app-input>
      <mat-chip-list>
        <mat-chip
          *ngFor="let header of getControl('oldHeaders').value"
        >
          {{ header }}
        </mat-chip>
                <mat-chip
          *ngFor="let header of getControl('headers').value"
          [removable]="true"
          (removed)="removeHeader(header)"
        >
          {{ header }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
      <span *ngIf="product" class="disclaimer">{{ labels.headersDisclaimer }}</span>
    </div>
</div>
